module.exports = __webpack_public_path__ + "media/svg/transparence-8c6ddfd1.svg";